import React from "react";
import Link from "next/link";

const Breadcrumbs = ({ ...props }) => {
  return (
    <div className="hidden lg:block container mx-auto text-sm mt-5 px-5 lg:px-0">
      <div className="flex space-x-2 items-center leading-none">
        <Link href="/">
          <a title="Home">
            <i className="fas fa-home text-brand-tertiary"></i>
          </a>
        </Link>
        {props.links?.length > 0 &&
          props.links?.map((elm) =>
            elm.map((item, index, links) => {
              if (index + 1 === links.length) {
                return (
                  <>
                    <span className="text-gray-400">/</span>
                    <span className="text-gray-600">{item[0]}</span>
                  </>
                );
              } else {
                if(index > 0){
                  return (
                    <>
                      <span className="text-gray-400">/</span>
                      <Link href={item[1]}>
                        <a title={item[2]}>
                          <span className="text-brand-tertiary">{item[0]}</span>
                        </a>
                      </Link>
                    </>
                  );
                }else{
                  return (
                  <>
                    <span className="text-gray-400">/</span>
                    <Link href={item[1]}>
                      <a title={item[2]}>
                        <span className="text-brand-tertiary">{item[0]}</span>
                      </a>
                    </Link>
                    </>
                  ); 
                }
              }
            })
          )}
      </div>
    </div>
  );
};

export default Breadcrumbs;
